import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import HistoryAccountEntriesDownloadButton
  from "@/components/history/HistoryAccountEntriesDownloadButton.vue";
import HistoryCsvDownloadButtonNew from "@/components/history/HistoryCsvDownloadButtonNew.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryExportBlock',
  props: {
  accountNumber: {type: String, default: ''},
  periodBegin: {type: String, default: ''},
  periodEnd: {type: String, default: ''},
  state: {type: String, default: null},
  textSearch: {type: String, default: ''},
},
  setup(__props) {

const props = __props;



const accountNumber = computed(() => props.accountNumber)
const periodBegin = computed(() => props.periodBegin)
const periodEnd = computed(() => props.periodEnd)
const state = computed(() => props.state)
const textSearch = computed(() => props.textSearch)

return { __sfc: true,props, accountNumber, periodBegin, periodEnd, state, textSearch, HistoryAccountEntriesDownloadButton, HistoryCsvDownloadButtonNew }
}

})